<template>
  <div class="flex flex-col space-y-2">
    <div class="font-text font-sans text-black lg:text-lg">
      {{ title }}
      <span v-if="required">*</span>
    </div>
    <select
      v-model="selected"
      :name="name"
      :hidden="hidden"
      :disabled="disabled"
      :required="required"
      :class="
        twMerge(
          'w-full flex-1 rounded-md border border-blue-dark p-3 leading-tight outline-0 focus:border-blue-dark focus:border-transparent focus:ring-0 focus-visible:border-blue-dark lg:p-4 lg:text-xl',
          styleInput,
        )
      "
      @blur="v$ && v$.$validate()"
    >
      <!-- @vue-skip -->
      <option value>- {{ $t('select') }} -</option>
      <option v-for="(item, index) in Object.entries(options)" :key="index" :value="item[0]">
        {{ item[1] }}
      </option>
    </select>
    <div
      v-if="v$?.$invalid && v$?.$dirty && v$?.$errors?.length > 0"
      :class="
        twMerge(
          'mt-0.5 flex w-full flex-col items-start rounded px-1 py-0 pr-3 font-sans text-sm text-pink',
          styleError,
        )
      "
      role="alert"
    >
      <span v-for="err in v$.$errors" :key="err.$uid">{{ err.$message }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
import { twMerge } from 'tailwind-merge'
import type { Validation } from '@vuelidate/core'

interface ISelectProps {
  id?: string
  title: string
  name?: string
  modelValue: string | number
  options: Record<string, string | number>
  required?: boolean
  disabled?: boolean
  hidden?: boolean
  styleInput?: string
  styleError?: string
  placeholder?: string
  v$?: Validation
}

const props = withDefaults(defineProps<ISelectProps>(), {
  hidden: false,
  disabled: false,
})

const emit = defineEmits(['update:modelValue'])

const selected = useVModel(props, 'modelValue', emit)
</script>
